import { ConcreteEncodable } from "./ConcreteEncodable";

import { DateTimeComparitorImplEncoder } from "../../encoder/DateTimeComparitorImplEncoder";

import * as CubiqTS from "../../index";
import { DateTimeComparitor } from "../DateTimeComparitor";

export class DateTimeComparitorImpl extends ConcreteEncodable implements DateTimeComparitor {
  public static enType: string = "com.bcdfx.model.DateTimeComparitorImpl";

  /*FID=1*/
  public timeComparison: CubiqTS.TimeComparison;
  /*FID=2*/
  public javaTimeZoneCd: string;
  /*FID=3*/
  public lowerBound: string;
  /*FID=4*/
  public upperBound: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = DateTimeComparitorImplEncoder.Instance;
    this.setEncodableType(DateTimeComparitorImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "DateTimeComparitorImpl[" +
      "timeComparison=" +
      this.timeComparison +
      "javaTimeZoneCd=" +
      this.javaTimeZoneCd +
      "lowerBound=" +
      this.lowerBound +
      "upperBound=" +
      this.upperBound +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
